import { DispositiveProvisionsFormRecipient } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsForm.types';
import { BeneficiaryDesignationTier } from '@/types/schema';

export const BENEFICIARY_DESIGNATIONS_FORM_NAMESPACE =
  'beneficiaryDesignations';

/**
 * Represents the recipients for a single tier (primary or contingent)
 * of a beneficiary designation group.
 */
export interface BeneficiaryDesignationTierFormValues {
  beneficiaryDesignationGroupId: string | null;
  tier: BeneficiaryDesignationTier;
  recipients: DispositiveProvisionsFormRecipient[];
  /**
   * When true, the residuary recipient(s) for this tier bear tax by default and
   * the per-recipient "net of taxes" toggle is hidden; when false, each
   * recipient's `bearsTax` is configured individually. Defaults from the
   * account's in-estate status. Materialized into per-DP `bearsTax` on submit;
   * persisted on the BeneficiaryDesignationGroup so the toggle reconstructs.
   */
  residuaryPaysAllTaxes: boolean;
  _associatedHypotheticalWaterfallId: string | null;
}

/**
 * Top-level form shape for the beneficiary designations editor.
 * Contains two tiers: primary and contingent.
 */
export interface BeneficiaryDesignationsFormShape {
  [BENEFICIARY_DESIGNATIONS_FORM_NAMESPACE]: {
    primary: BeneficiaryDesignationTierFormValues;
    contingent: BeneficiaryDesignationTierFormValues;
  };
}

export type BeneficiaryDesignationsFormNamespace =
  | `${typeof BENEFICIARY_DESIGNATIONS_FORM_NAMESPACE}.primary`
  | `${typeof BENEFICIARY_DESIGNATIONS_FORM_NAMESPACE}.contingent`;
